import React, { memo } from 'react';
import { Handle, Position } from '@xyflow/react';
import './ProcessNodes.css';

/**
 * Python Node -- canvas card for the `python` execution type.
 *
 * Surfaces the entrypoint name, a line-count of the user code, and the
 * number of MCP servers the node is allowed to reach so the operator
 * can identify the node from the canvas alone.
 */
function PythonNode({ data, selected }) {
  const inputCount = data.inputs?.length || 0;
  const outputCount = data.outputs?.length || 0;
  const cfg = data.python_config || {};
  const entrypoint = cfg.entrypoint || 'main';
  const codeLines = cfg.code ? cfg.code.split('\n').length : 0;
  const mcpCount = (cfg.mcp_servers && cfg.mcp_servers.length) || 0;

  return (
    <div className={`process-node python-node ${selected ? 'selected' : ''}`}>
      <Handle type="target" position={Position.Left} className="node-handle input-handle" />

      <div className="node-header">
        <span className="node-icon">🐍</span>
        <span className="node-type-badge python">PYTHON</span>
      </div>

      <div className="node-body">
        <div className="node-name">{data.name || 'Python Node'}</div>
        {data.description && (
          <div className="node-description">{data.description}</div>
        )}
        <div className="node-python-summary">
          <span className="python-entrypoint">{entrypoint}()</span>
          <span className="python-lines">{codeLines} line{codeLines !== 1 ? 's' : ''}</span>
        </div>
      </div>

      <div className="node-footer">
        <div className="node-meta">
          <span className="meta-item">
            <span className="meta-icon">↓</span>
            {inputCount} input{inputCount !== 1 ? 's' : ''}
          </span>
          <span className="meta-item">
            <span className="meta-icon">↑</span>
            {outputCount} output{outputCount !== 1 ? 's' : ''}
          </span>
        </div>
        <div className="node-model">
          {mcpCount > 0 ? `MCP: ${mcpCount}` : (cfg.network_access ? 'net: on' : 'sandboxed')}
        </div>
      </div>

      <Handle type="source" position={Position.Right} className="node-handle output-handle" />
    </div>
  );
}

export default memo(PythonNode);
